/**
 * Created by Smile on 2017/9/2.
 */
import * as $ajax from '../router/http'
import * as Util from 'util'

// api版本
const prefix = Util.getApiVersion()

 /**
  * 创建外链
  */
export function create (params) {
  let url = prefix + '/delivery/create/databox' + params.path + '?account_id=1&uid=' + Util.getUserId()

  let postData = {
    mode: params.mode,
    password: params.password,
    expiration: params.expiration
  }

  if (params.neid) {
    postData.neid = params.neid
  } else {
    postData.path_type = params.path_type
    postData.from = params.from
  }
  if (params.prefix_neid) {
    postData.prefix_neid = params.prefix_neid
  }

  return $ajax.ajaxPost(encodeURI(url), postData)
}

/**
 *  获取外链信息
 */
export function getDeliveryInfo (params) {
  let url = prefix + '/delivery/info/' + params.code + '?account_id=1&uid=' + Util.getUserId()
  return $ajax.ajaxGet(encodeURI(url))
}

/**
 *  取消外链信息
 */
export function delDelivery (params) {
  let url = prefix + '/delivery/batch_delete' + '/' + '?account_id=1&uid=' + Util.getUserId()
  return $ajax.ajaxPost(encodeURI(url), params)
}

/**
 * 获取外链文件/目录的元数据
 @param {object} params
 @param {function} params.callback 回调函数
 @param {string} params.code 外链编码
 @param {string} params.relative_path 要查看的内容相对于外链的路径信息
 @param {string} params.token 访问令牌
 @param {string} params.order_type 默认mtime
 @param {string} params.sort 默认desc
 @param {string} params.offset 文件列表起始偏移量
 @param {string} params.limit 文件列表条数限制
 */
export function deliveryMetadata (params) {
  if (!params.code) {
    return {code: 999, data: null, message: 'code不能为空!'}
  }
  var url = prefix + '/metadata/' + params.code
  if (params.relative_path) {
    url += '/' + params.relative_path
  }
  var queryString = []
  if (params.token) {
    queryString.push('token=' + params.token)
  }
  if (params.order_type) {
    queryString.push('orderby=' + params.order_type)
  }
  if (params.sort) {
    queryString.push('sort=' + params.sort)
  }

  if (params.offset !== undefined) {
    queryString.push('offset=' + params.offset)
  }
  if (params.limit) {
    queryString.push('limit=' + params.limit)
  }
  if (params.preview_type) {
    queryString.push('preview_type=origin')
  }
  if (params.user_op) {
    queryString.push('user_op=preview')
  }
  if (queryString.length > 0) {
    url += '?' + queryString.join('&')
  }
  url = url.replace('//', '/')
  return $ajax.ajaxGet(encodeURI(url))
}

/**
 * 外链转存
 @param {object} params
 @param {function} params.callback 回调函数
 */
export function deliveryTransfor (params) {
  let url = prefix + '/delivery/delivery_transfor'
  let data = JSON.stringify({
    from: params.from,
    to: params.to,
    other_data: params.other_data,
    nsid: window.nsid
  })
  let postData = {
    json: data
  }
  return $ajax.ajaxPost(encodeURI(url), postData)
}



// WEBPACK FOOTER //
// ./src/SDK/DeliveryManager.js